import { Component, OnInit } from '@angular/core';
import { BaseViewInvoiceComponent } from '../../../core/components/base-view-invoice.component';
import { Sinvoice } from '@cl/shared/models/sinvoices/sinvoice.model';
import { SinvoicesService } from '@cl/core/services/sinvoices.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { Department, EntityType, PaymentStatus } from '@cl/shared/models';
import { DepartmentPermissionsType } from '@cl/shared/department-permissions-type.enum';
import { GroupPermissionsType } from '@cl/shared/group-permissions-type.enum';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@cl/shared/constants';
import { DepartmentsService, UsersService } from '@cl/core/services';
import { faCode, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { EmployeeNotificationsService } from '@cl/core/services/employee-notifications.service';
import { TableSorters } from '@cl/shared/table-sorters';
import { Payment } from '@cl/shared/models/payments/payment.model';
import { Invoice } from '@cl/shared/models/invoices/invoice.model';
@Component({
    selector: 'cl-view-sinvoice',
    standalone: false,
    templateUrl: './view-sinvoice.component.html',
    styleUrl: './view-sinvoice.component.less',
})
export class ViewSinvoiceComponent extends BaseViewInvoiceComponent<Sinvoice, SinvoicesService> implements OnInit {
    EntityType = EntityType;
    DepartmentPermissions = DepartmentPermissionsType;
    GroupPermission = GroupPermissionsType;
    PaymentStatus = PaymentStatus;
    DATE_FORMAT = DATE_FORMAT;
    DATE_TIME_FORMAT = DATE_TIME_FORMAT;

    fromSinvoices: boolean = false;

    xmlIcon: IconDefinition = faCode;

    constructor(
        protected sinvoicesService: SinvoicesService,
        protected messageService: NzMessageService,
        protected modalService: NzModalService,
        protected usersService: UsersService,
        protected employeeNotificationsService: EmployeeNotificationsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private departmentsService: DepartmentsService,
    ) {
        super(sinvoicesService, messageService, modalService, usersService, employeeNotificationsService);
    }

    async ngOnInit(): Promise<void> {
        this.loading = true;
        this.fromSinvoices = this.activatedRoute.snapshot.data['fromSinvoices'];
        const invoiceId: number = this.activatedRoute.snapshot.params['id'];
        if (!invoiceId) {
            this.router.navigate(this.fromSinvoices ? ['bookkeeper', 'sinvoices'] : ['base-data', 'invoices']);
            return;
        }

        await this.reloadInvoice(invoiceId);
    }

    edit(): void {
        this.router.navigate(
            this.fromSinvoices
                ? ['bookkeeper', 'sinvoices', 'edit-sinvoice', this.invoiceData.id]
                : ['base-data', 'invoices', 'edit-sinvoice', this.invoiceData.id],
        );
    }

    async reloadInvoice(invoiceId: number): Promise<void> {
        try {
            this.loading = true;
            this.invoiceData = (await this.sinvoicesService.getInvoiceDetails(invoiceId)).data;
            this.loading = false;
            if (!this.invoiceData) {
                this.messageService.error('Virsrēķins nav atrasts');
                this.router.navigate(this.fromSinvoices ? ['bookkeeper', 'sinvoices'] : ['base-data', 'invoices']);
                return;
            }
        } catch (ex) {
            this.loading = false;
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                this.router.navigate(this.fromSinvoices ? ['bookkeeper', 'sinvoices'] : ['base-data', 'invoices']);
                return;
            }

            this.messageService.error('Kļūda atlasot virsrēķina informāciju');
            this.router.navigate(this.fromSinvoices ? ['bookkeeper', 'sinvoices'] : ['base-data', 'invoices']);
            return;
        }
    }

    back(): void {
        this.router.navigate(this.fromSinvoices ? ['bookkeeper', 'sinvoices'] : ['base-data', 'invoices']);
    }

    departmentToString(department: Department) {
        return this.departmentsService.toString(department);
    }

    readonly sortByPaymentTypeName = TableSorters.sortString<Payment>((e) => e.paymentTypeName);
    readonly sortByPaymentBankReference = TableSorters.sortString<Payment>((e) => e.bankReference);
    readonly sortByPaymentDate = TableSorters.sortDate<Payment>((e) => e.date);
    readonly sortByPaymentSumWithVat = TableSorters.sortNumber<Payment>((e) => e.sumWithVat);
    readonly sortByPaymentAccepted = TableSorters.sortBoolean<Payment>((e) => e.accepted);
    readonly sortByPaymentStatusName = TableSorters.sortString<Payment>((e) => e.statusName);

    readonly sortByInvoiceNumber = TableSorters.sortString<Invoice>((e) => e.number);
    readonly sortByInvoiceDate = TableSorters.sortDate<Invoice>((e) => e.date);
    readonly sortByInvoiceUntilDate = TableSorters.sortDate<Invoice>((e) => e.untilDate);
    readonly sortByInvoiceSumWithVat = TableSorters.sortNumber<Invoice>((e) => e.sumWithVat);
    readonly sortByInvoiceIsPaid = TableSorters.sortBoolean<Invoice>((e) => e.isPaid);
    readonly sortByInvoiceUnpaidSum = TableSorters.sortNumber<Invoice>((e) => e.unpaidSum);
}
